<template>
  <!-- This component will delete selected topic/module - user is warned before deletion takes place -->
  <a href="#" @click="deleteLesson" class="text-secondary">Delete</a>
</template>

<script>
import axios from "axios";

export default {
  props: {
    lesson: {},
    topicIndex: Number,
    lessonIndex: Number,
  },
  methods: {
    deleteLesson() {
      this.$swal
        .fire({
          title: "Are you sure?",
          text: `This action will delete "${this.lesson.name}" lesson and its content.`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!",
        })
        .then((result) => {
          if (result.value) {
            axios.post("/authoring/lessons/delete/" + this.lesson.uuid).then((res) => {
              if (res.data.status == "success") {
                //this.$store.state.topics[topicIndex].children.splice(lessonIndex, 1);
                this.$emit("lessonDeleted", { topicIndex: this.topicIndex, lessonIndex: this.lessonIndex });
                this.$swal.fire("Deleted!", res.data.message, "success");
              }
            });
          }
        });
    },
  },
};
</script>

<style>
</style>